export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/download-6f055584189e7b61635c0b35b6509169.svg";